import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetEventListBo } from './events.modal';
@Injectable({
  providedIn: 'root'
})
export class EventsServices extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent
  ) {
    super()
  }
  public outputValues(EventsState: GetEventListBo): void {
    this.getEventsList(EventsState).subscribe(x => super.next(x));
  }
  getEventsList(EventsState?: GetEventListBo): Observable<DataStateChangeEventArgs> {
    console.log(EventsState);
    return this.http.post<any>("api/Event/GetEventList", EventsState)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count'],
            
          }
      )).pipe(map((e: any) => {
        e?.result?.forEach((ele) => {
        })
        return e;
        
      }))
  }
  GetAllClientDropDown(url): Observable<any> {
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetUserDropDown(): Observable<any> {
    let url = "api/Event/GetEventUserDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  SaveEvents(data: any): Observable<any> {
    let url = "api/Event/SaveEvent";
    return this.http.post(url, data, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getLovValues(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Lov/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  DeleteEvent(paramsData: URLSearchParams) {
    let url = "api/Event/deleteEvent?"
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  getDropdown(url): Observable<any> {
   // let url = "api/User/GetUserDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}
